export default class UserRequest {
  email = '';
  password = '';

  build () {
    const { email, password } = this;
    return {
      email,
      password,
    };
  }
}
